<div class="register-page screen-bottom-halo">
  <div class="logo-container">
    <img class="logo-icon" src="assets/images/explain-logo-900.svg" alt="explain_logo" />
    <img class="logo-text" src="assets/images/explain-text-900.svg" alt="explain_text" />
  </div>

  <div class="register-card">
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>
      <div class="card-header">
        <h1 class="card-title">{{ 'register.title' | translate }}</h1>
        <p class="card-subtitle">{{ 'register.sub-title' | translate }}</p>
      </div>

      <div class="form-fields">
        <!-- Email field -->
        <div class="form-field">
          <label for="email" class="field-label">{{ 'register.email' | translate | uppercase }}</label>
          <input
            type="email"
            formControlName="email"
            class="field-input"
            id="email"
            [ngClass]="{ 'field-input--error': (submitted && f['email'].errors) || errorMessage }"
            [placeholder]="'register.email-placeholder' | translate"
            (input)="onInputChange()"
            data-cy="register-email-input"
          />
          <ngx-turnstile
            [siteKey]="environment.captchaPublicKey"
            #turnstileComponent
            action="sign_up"
            theme="light"
            (resolved)="handleCaptcha($event)"
            (errored)="handleError()"
          />

          <!-- Validation errors -->
          @if (submitted && f['email'].errors) {
            <div class="error-box">
              <i class="ph ph-warning-circle error-icon"></i>
              <p class="error-text">
                @if (f['email'].errors?.['required']) {
                  <span>{{ 'register.error-email-required' | translate }}</span>
                } @else if (f['email'].errors?.['email']) {
                  <span>{{ 'register.error-email-invalid' | translate }}</span>
                } @else if (f['email'].errors?.['minlength']) {
                  <span>{{ 'register.error-email-min-length' | translate }}</span>
                }
              </p>
            </div>
          }

          <!-- API errors -->
          @if (errorMessage) {
            <div class="error-box">
              <svg
                class="error-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <p class="error-text">
                {{ errorMessage | translate }}
                @if (showLoginLink) {
                  <a [routerLink]="['/login']" class="error-login-link">{{ 'register.login-link' | translate }}</a>
                }
              </p>
            </div>
          }
        </div>

        <!-- Submit button -->
        <div class="button-container">
          <button type="submit" class="btn-submit" [disabled]="loading" data-cy="register-submit-btn">
            @if (loading) {
              <svg
                class="btn-loader"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="12" y1="2" x2="12" y2="6"></line>
                <line x1="12" y1="18" x2="12" y2="22"></line>
                <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                <line x1="2" y1="12" x2="6" y2="12"></line>
                <line x1="18" y1="12" x2="22" y2="12"></line>
                <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
              </svg>
            }
            <span>{{ (loading ? 'register.submitting' : 'register.submit') | translate }}</span>
          </button>
        </div>

        <!-- Social login -->
        <div class="social-section">
          <div class="or-separator">
            <div class="or-separator-line"></div>
            <div>{{ 'login.or' | translate }}</div>
            <div class="or-separator-line"></div>
          </div>

          <div class="social-buttons">
            <button type="button" class="btn-social" (click)="socialSignin('google')" data-cy="google-signin">
              <img src="assets/images/google-logo.svg" class="social-icon" alt="Google" />
              <span>{{ 'login.sign-in-with-google' | translate }}</span>
            </button>
            <button type="button" class="btn-social" (click)="socialSignin('microsoft')" data-cy="microsoft-signin">
              <img src="assets/images/microsoft-logo.svg" class="social-icon" alt="Microsoft" />
              <span>{{ 'login.sign-in-with-microsoft' | translate }}</span>
            </button>
          </div>

          @if (socialError) {
            <div class="error-box">
              <i class="ph ph-warning-circle error-icon"></i>
              <p class="error-text">{{ 'login.social-error' | translate }}</p>
            </div>
          }

          <!-- CGU notice -->
          <p class="cgu-notice">
            {{ 'register.cgu-notice' | translate }}
            <a class="cgu-notice-link" [href]="cguUrl" target="_blank" rel="noopener noreferrer">{{ 'register.cgu-link' | translate }}</a
            >.
          </p>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <p class="footer-text">
    {{ 'register.already-account' | translate }}
    <a [routerLink]="['/login']" class="footer-link">{{ 'register.login-link' | translate }}</a>
  </p>
</div>
